import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@env';
import { CompanySessionService } from './company-session.service';

/**
 * Company-scoped pages need an active company: without one they can't load anything and
 * the sidebar hides its company switcher and every role-gated item, stranding the
 * employer. Sends them to the company picker, which resolves whatever memberships remain.
 */
export const companySessionGuard: CanActivateFn = () => {
  if (environment.isDev && environment.devBypassOnboardedConstraint) return true;

  const session = inject(CompanySessionService);
  const router = inject(Router);
  return session.hasCompanySession() && session.activeMembership() ? true : router.createUrlTree(['/select-company']);
};
